import { clsx } from 'clsx';
import { Button } from 'src/components/ui/button';
import React, { useEffect } from 'react';
import { useResendVerificationEmailMutation } from 'src/services/usersSsoService';
import { useNotification } from 'src/hooks/useNotification';
import { useCountDown } from 'src/hooks/useCountDown';
import { useLoaderWhile } from 'src/hooks/useLoaderWhile';

export const ResendVerificationEmailButton = ({ disabled = false, ...props }) => {
  const notification = useNotification();
  const { isRunning, start } = useCountDown(3600, 'email_verify_countdown', 'm:ss');
  const [visible, setVisible] = React.useState(!isRunning);
  const [resendVerificationEmail, { isLoading: isLoadingResendVerificationEmail }] =
    useResendVerificationEmailMutation();

  useLoaderWhile(isLoadingResendVerificationEmail);

  useEffect(() => {
    setVisible(!isRunning);
  }, [isRunning]);

  const onClick = () => {
    resendVerificationEmail(undefined).then((resendVerificationEmailResult) => {
      if (!('error' in resendVerificationEmailResult)) {
        notification.success('Verification email has been sent');
      }
    });
    start();
  };

  return visible ? (
    <Button
      variant="blue"
      size="sm"
      disabled={disabled || isRunning}
      className={clsx(disabled && 'pointer-events-none opacity-50')}
      onClick={onClick}
      {...props}
    >
      <p className="font-semibold text-[11px]">Resend verification email</p>
    </Button>
  ) : null;
};
